import { Dialog, Transition } from '@headlessui/react';
import {  XMarkIcon } from '@heroicons/react/24/outline';
import React, { Fragment, useRef } from 'react';

function Terms({ isOpen = false, onClose, title, contestDetails }) {
  
    const cancelButtonRef = useRef(null);
    let data;
    if (contestDetails.contest.polices) {
        data = JSON.parse(contestDetails.contest.polices);
    }




    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={onClose}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl">
                                <div className="bg-white px-4 lg:pb-2 pt-5 sm:p-6 sm:pb-4">
                                    <div className="w-full mb-2 flex items-center justify-between font-bold text-center sm:text-left">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-bold leading-6 text-gray-900"
                                        >
                                            {title}
                                        </Dialog.Title>
                                        <button
                                            type="button"
                                            className="rounded-full border-2 border-gray-400 p-0.5 bg-white text-gray-500"
                                            onClick={onClose}
                                        >
                                            <span className="sr-only">
                                                Close
                                            </span>
                                            <XMarkIcon
                                                className="h-4 w-4"
                                                aria-hidden="true"
                                            />
                                        </button>
                                    </div>
                                </div>
                                <div className="w-full border border-dashed border-gray-300"></div>
                                <div className="bg-white px-4 pb-4 lg:pt-2 sm:p-6 sm:pb-4 max-h-[70vh] overflow-y-auto scrollbar-custom">
                                    <div dangerouslySetInnerHTML={{ __html: data?.terms_content }} />
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default Terms